import { render, staticRenderFns } from "./PictureReq.vue?vue&type=template&id=6c22162c&"
import script from "./PictureReq.vue?vue&type=script&lang=js&"
export * from "./PictureReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports